import { BsArrowLeft } from "react-icons/bs";
import { RiArrowRightSLine } from "react-icons/ri";
import img1 from '../../../Assets/case_1.png'
import img2 from '../../../Assets/case_1_1.png'
import img3 from '../../../Assets/case_1_2.png'
import avatar from '../../../Assets/avatar_teste.png'
import * as S from './styles';

export const Icc = () => {
  return (
    <S.Wrapper>

      <S.HeaderBar>
        <S.BackButton
          onClick={() => window.history.back()} aria-label="Voltar"
        >
          <BsArrowLeft size={40} />
        </S.BackButton>
        <h2>ICC​</h2>
      </S.HeaderBar>

      <S.Grid>
        <S.Sidebar>
          <S.SideBlock>

            <S.SideTitle>
              Overview
            </S.SideTitle>

            <p>
              O Iate Club de Caiobá é sinônimo de exclusividade, lazer e tradição à beira-mar. Porém, o controle de acesso era um desafio constante — falhas, burocracia e insegurança comprometiam a experiência dos associados e a tranquilidade da gestão.
            </p>

            <p>
              Com a solução desenvolvida pela Bindflow, o clube conquistou segurança, agilidade e confiabilidade no controle de acesso. O sistema reconhece cada associado de forma automatizada e sem contato, tornando o processo mais prático e preciso.
            </p>

          </S.SideBlock>

          <S.SideBlock>
            <S.SideTitle>Entregáveis</S.SideTitle>
            <ul>
              <li><p>Implementação do sistema de reconhecimento facial.</p></li>
              <li><p>Integração com infraestrutura de acesso existente.</p></li>
              <li><p>Relatórios inteligentes e monitoramento em tempo real.</p></li>
              <li><p>Acesso seguro e ágil, eliminando filas e falhas humanas.</p></li>
              <li><p>Gestão eficiente, com dados precisos e centralizados.</p></li>
              <li><p>Imagem de inovação, reforçando o posicionamento premium do clube.</p></li>
            </ul>
          </S.SideBlock>
        </S.Sidebar>

        <S.Main>
          <S.Img src={img1} alt="Hero" />

          <S.TwoCol>
            <S.Img src={img2} alt="" />
            <S.Img src={img3} alt="" />
          </S.TwoCol>

        </S.Main>
      </S.Grid>
    </S.Wrapper >
  );
};
